<template>
  <div class="health-page">
    <header class="health-header">
      <div class="health-header-avatar">
        <img src="@/assets/patient/patient_cal.png" alt="">
      </div>
      <div class="health-header-text">
        <div class="health-header-date">{{ title_today }}</div>
        <div class="health-header-name">{{ patientName }}</div>
      </div>
    </header>

    <el-row>
      <el-col :span="24">
        <div class="health-section">
          <el-card class="box-card health-profile-card" shadow="hover">
            <div slot="header" class="clearfix card-header health-card-head">
              <i class="el-icon-card-header"></i>
              <span>基本信息</span>
            </div>
            <el-row :gutter="12" class="health-profile-row">
              <!-- 基本信息通过配置化数据渲染 -->
              <div class="health-profile-grid text item">
                <div class="user-profile-item" v-for="item in profileEntries" :key="item.key">
                  <div class="el-col-tbl-key">{{ item.key }}</div>
                  <div class="el-col-tbl-val">{{ item.displayValue }}</div>
                </div>
              </div>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <!-- 健康信息卡片列表：Grid 等分列，避免 el-col 不同 span 导致宽窄不一、换行错位 -->
    <div class="health-metrics-grid">
      <div
        v-for="card in healthCards"
        :key="card.key"
        class="health-metrics-cell"
      >
        <el-card class="health-card" shadow="hover">
          <div class="health-card-inner">
            <div class="health-card-icon-wrap">
              <el-image :src="card.icon" class="health-card-icon" fit="contain" />
            </div>
            <div class="health-card-content">
              <div class="numClass health-card-value" :style="card.valueStyle || {}">{{ card.value }}</div>
              <div class="hintClass health-card-label">{{ card.label }}</div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <el-row :gutter="20" class="predict-card-row health-charts-row">
      <!-- 预测图表配置化渲染 -->
      <el-col v-for="card in predictChartCards" :key="card.key" :span="12" :xs="24" :sm="24" :md="12">
        <el-card class="box-card health-predict-card" shadow="hover">
          <div slot="header" class="clearfix card-header health-card-head">
            <i class="el-icon-card-header"></i>
            <span>{{ card.title }}{{ card.titleSuffix }}</span>
          </div>
          <div class="health-chart-cell">
            <PieChart :id="card.chartId" :path="card.path" height="500px"></PieChart>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PieChart from "@/views/charts/pie";
import {getTime} from "@/utils";
import '@/assets/css/main.css';
import {Role} from "@/role";

const API_HOST = process.env.VUE_APP_API_HOST;
const JSON_HEADERS = {"content-type": "application/json"};
// 基本信息字段格式化配置
const PROFILE_DATE_KEYS = ['最近一次问诊', '最早问诊'];
const PROFILE_MASK_KEYS = ['电话号码', '出生日期', '年龄'];
// 健康卡片配置
const HEALTH_CARD_CONFIGS = [
  {
    key: 'overall_health',
    span: 4,
    icon: require('@/assets/patient/health_1.png'),
    value: '好',
    label: '整体身体状况',
    valueStyle: {color: '#60FCB2'}
  },
  {
    key: 'recent_disease',
    span: 6,
    icon: require('@/assets/patient/health_2.png'),
    value: '脾胃虚，泻',
    label: '近期疾病'
  },
  {
    key: 'visit_count',
    span: 4,
    icon: require('@/assets/patient/health_3.png'),
    value: '20',
    label: '最近就诊次数'
  },
  {
    key: 'consume',
    span: 6,
    icon: require('@/assets/patient/health_4.png'),
    value: '1400.00元',
    label: '消费'
  },
  {
    key: 'drink',
    span: 4,
    icon: require('@/assets/patient/health_5.png'),
    value: '轻燕饮',
    label: '建议饮用'
  },
  {
    key: 'care',
    span: 4,
    icon: require('@/assets/patient/health_6.png'),
    value: '推拿',
    label: '建议保健'
  },
  {
    key: 'food',
    span: 6,
    icon: require('@/assets/patient/health_7.png'),
    value: '大麦',
    label: '建议食物'
  }
];
// 预测图表配置
const PREDICT_CHART_CONFIGS = [
  {
    key: 'disease_predict',
    title: '未来一个月疾病预测',
    chartId: 'user_profile_city_disease_predict',
    path: 'user_profile_city_disease_predict'
  },
  {
    key: 'weather_predict',
    title: '未来一个月温度预测:',
    chartId: 'user_profile_city_weather_predict_pie',
    path: 'user_profile_city_weather_predict_pie'
  }
];


export default {
  name: "Health",
  components: {
    PieChart,
  },
  data() {
    return {
      avg_temp: null,
      yinqing_dict: null,
      user_profile_data: null,
      title_today: '2021-01-01',
      patient_id: this.$route.query.patient_id ? this.$route.query.patient_id : (localStorage.getItem('user_id') ? localStorage.getItem('user_id') : '637377'),
      city_id: this.$route.query.city_id ? this.$route.query.city_id : '637377',
      city_name: this.$route.query.city_name ? this.$route.query.city_name : '怀化市',
      pred_dis_result: [],
      textForm: {
        u_birth_day: '2018-05-09',
        u_gender: '1',
        u_sym: "{\n\t\"2020-02-27\": \"咽喉炎\",\n" +
            "\t\"2020-02-29\": \"风热咳嗽\",\n" +
            "\t\"2020-03-02\": \"风寒感冒\",\n" +
            "\t\"2020-03-14\": \"风热咳嗽\"\n}",
      },
      // 健康卡片数据配置 — 不占用 patientName，顶栏姓名仅来自下方 computed
      healthCards: HEALTH_CARD_CONFIGS
    }
  },
  computed: {
    isDemo() {
      return this.$store.getters.user_role === Role.Demo
    },
    profileEntries() {
      if (!this.user_profile_data) {
        return [];
      }
      return Object.keys(this.user_profile_data).map((key) => ({
        key,
        displayValue: this.formatProfileValue(key, this.user_profile_data[key])
      }));
    },
    // 顶栏姓名：依赖 user_profile_data，需作为 computed 才能保证随接口更新
    patientName() {
      const d = this.user_profile_data
      if (!d) return ''
      return d['姓名'] || ''
    },
    predictChartCards() {
      return PREDICT_CHART_CONFIGS.map((card) => ({
        ...card,
        titleSuffix: card.key === 'weather_predict' ? this.avg_temp || '' : ''
      }))
    }
  },
  mounted() {
    this.title_today = getTime();
    this.get_user_predict_weather()
    this.query_pred_disease()
    this.get_user_profile()
  },
  methods: {
    // 统一处理基本信息字段显示
    formatProfileValue(key, value) {
      if (value === null || value === undefined) {
        return '';
      }
      if (PROFILE_DATE_KEYS.includes(key)) {
        return String(value).split('T').join(' ');
      }
      if (this.isDemo && PROFILE_MASK_KEYS.includes(key)) {
        return "******";
      }
      return value;
    },
    get_user_profile() {
      this.$http.get(API_HOST + "/user_profile?patient_id=2049104109349707778").then((res) => {
        this.user_profile_data = res.data.data
      })
    },
    get_user_predict_weather() {
      this.$http.get(API_HOST + "/user_profile_city_weather_predict").then((res) => {
        this.avg_temp = res.data.avg_tempreate;
        this.yinqing_dict = res.data.yinqing_dict;
      })
    },
    query_pred_disease() {
      this.$http.post(API_HOST + "/user_disease_predict", this.textForm, JSON_HEADERS).then((res) => {
        this.pred_dis_result = res.data.data;
      })
    },
    // 斑马纹行样式
    tableRowClassName({rowIndex}) {
      return rowIndex % 2 === 1 ? 'warning-row1' : 'success-row1';
    },
  }
}
</script>

<style scoped>
/**
 * 患者健康页：仅样式与布局类名，不改变 script 中的数据与接口逻辑。
 * 配色与 Basic/MedicalRecordDetail 深色卡片体系对齐。
 */

/* 页面边距与最大宽度，避免大屏上内容铺满显得散 */
.health-page {
  min-height: 100%;
  padding: 0 22px 32px;
  box-sizing: border-box;
  max-width: 1400px;
  margin: 0 auto;
}

/* 顶栏：与 Basic 页风格统一的日期 + 姓名 */
.health-header {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 4px 20px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.health-header-avatar {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(104, 245, 185, 0.28);
  background: linear-gradient(145deg, rgba(104, 245, 185, 0.15), rgba(60, 63, 74, 0.9));
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
}

.health-header-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.health-header-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.health-header-date {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.52);
  letter-spacing: 0.03em;
}

.health-header-name {
  font-size: 21px;
  font-weight: 700;
  color: #f5f7fb;
  letter-spacing: 0.02em;
  line-height: 1.28;
}

.health-section {
  margin-bottom: 8px;
}

/* 区块标题（病例/图表通用） */
.health-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
}

.health-profile-card .health-card-head {
  font-size: 14px;
}

.card-header {
  border: none;
}

/* 基本信息卡片 */
.health-profile-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.health-profile-card :deep(.el-card__header) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 11px 16px;
  height: auto;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.1) 100%);
}

.health-profile-card :deep(.el-card__body) {
  background: #363944;
  padding: 10px 16px 14px;
}

.health-profile-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* 基本信息：两列栅格，标签弱化、数值清晰 */
.health-profile-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.user-profile-item {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 50%;
  padding: 3px 8px 3px 0;
  gap: 6px 8px;
}

.el-col-tbl-key {
  min-width: 80px;
  max-width: 40%;
  flex-shrink: 0;
  line-height: 1.35;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
}

.el-col-tbl-val {
  flex: 1;
  min-width: 0;
  line-height: 1.35;
  font-size: 13px;
  font-weight: 500;
  color: #f0f2f6;
  word-break: break-word;
}

@media (max-width: 768px) {
  .user-profile-item {
    width: 100%;
    padding-right: 0;
  }

  .el-col-tbl-key {
    max-width: 38%;
  }
}

/* 健康指标：等宽网格（配置里 span 仅作历史字段保留，布局不再依赖它） */
.health-metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px 18px;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
}

.health-metrics-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1200px) {
  .health-metrics-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .health-metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .health-metrics-grid {
    grid-template-columns: 1fr;
  }
}

.health-card {
  height: 100%;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(165deg, #464a54 0%, #363944 100%);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.14);
  transition: border-color 0.2s ease, box-shadow 0.22s ease;
}

.health-card:hover {
  border-color: rgba(104, 245, 185, 0.22);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.2);
}

.health-card :deep(.el-card__body) {
  padding: 14px 16px 16px;
  background: transparent;
}

.health-card-inner {
  display: flex;
  align-items: center;
  gap: 14px;
}

.health-card-icon-wrap {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.health-card-icon {
  width: 36px;
  height: 36px;
}

.health-card-content {
  flex: 1;
  min-width: 0;
  width: auto;
}

/* 覆盖 main.css 中大号数字的行高，使卡片更紧凑协调 */
.health-card-value.numClass {
  font-size: 18px;
  line-height: 1.25;
  font-weight: 600;
  margin-bottom: 2px;
}

.health-card-label.hintClass {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.75;
}

/* 预测图表面板 */
.health-charts-row {
  margin-top: 4px !important;
}

.health-predict-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.16);
  margin-bottom: 20px;
}

.health-predict-card :deep(.el-card__header) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 14px 20px;
  height: auto;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.1) 100%);
}

.health-predict-card :deep(.el-card__body) {
  background: #363944;
  padding: 12px 14px 18px;
}

.health-chart-cell {
  width: 100%;
  min-height: 500px;
  box-sizing: border-box;
}

.predict-card-row {
  margin-top: 0;
}
</style>
